/** URL `?tab=` values for AMC contract overview. */
export const AmcContractOverviewTabParam = {
  OVERVIEW: "overview",
  VISITS: "visits",
  ATTACHMENTS: "attachments",
} as const;

export type AmcContractOverviewTabParamValue =
  (typeof AmcContractOverviewTabParam)[keyof typeof AmcContractOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, AmcContractOverviewTabParamValue> = {
  "1": AmcContractOverviewTabParam.OVERVIEW,
  "2": AmcContractOverviewTabParam.VISITS,
  "3": AmcContractOverviewTabParam.ATTACHMENTS,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [AmcContractOverviewTabParam.OVERVIEW]: "1",
  [AmcContractOverviewTabParam.VISITS]: "2",
  [AmcContractOverviewTabParam.ATTACHMENTS]: "3",
  // Legacy param — line items moved into an accordion on the Overview tab.
  "line-items": "1",
};

export function amcContractOverviewTabIdFromSearchParam(
  tab: string | null,
): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForAmcContractOverviewTabId(
  tabId: string,
): AmcContractOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidAmcContractOverviewTabParam(
  tab: string | null,
): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
